export default "__VITE_ASSET__0b85dec4__"